export default "__VITE_ASSET__1903ae29__"